<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>再エネ賦課金単価</mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <form [formGroup]="reEnergyTankaResultForm">
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-md:max-w-[full]">
                    <mat-label>適用年度</mat-label>
                    <input matInput readonly="true" required formControlName="applyYear" autocomplete="off"
                        class="font-color-display-only" />
                </mat-form-field>
                <mat-form-field appearance="outline"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[15%] tw-md:max-w-[full]">
                    <mat-label>再エネ賦課金単価</mat-label>
                    <input matInput formControlName="slideadjustmentunitprice" style="text-align:right"
                        autocomplete="off" (blur)="onBlurNumber()" [maxlength]="numberCommaMaxLength" />
                    <span matSuffix class="tw-ml-[5px]">円</span>
                </mat-form-field>
            </div>

            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
                <mat-card-actions class="btn_area_right">
                    <button *ngIf="isRegistVisible" type="submit" (click)="onClickRegistration()" mat-raised-button
                        color="primary" [disabled]="parentForm.invalid" class="btn">登録</button>
                </mat-card-actions>
                <mat-card-actions class="btn_area_right">
                    <button *ngIf="isDeleteVisible" type="submit" (click)="onClickDelete()" mat-raised-button
                        color="primary" class="btn">取消</button>
                </mat-card-actions>
                <mat-card-actions class="btn_area_right">
                    <button *ngIf="isApproveVisible" type="submit" (click)="onClickApproval()" mat-raised-button
                        color="primary" class="btn">承認</button>
                </mat-card-actions>
            </div>
        </form>
    </mat-card-content>
</mat-card>